module.exports = __webpack_public_path__ + "static/media/ricarica_condizionatori_blue.29a67588.png";